import { http } from '@/utils/http'
import { executeWithSpinner } from '@/utils/spinner'

export default {
  async createTransaction (updateData) {
    return new Promise((resolve, reject) => {
      http.main.post('/transactions/add', updateData).then(async (res) => {
        resolve(res.data)
      }).catch((err) => {
        reject(err)
      })
    })
  },
  async deleteTransaction (txId) {
    return new Promise((resolve, reject) => {
      http.main.post('/transactions/delete', {id: txId}).then(async (res) => {
        resolve(res.data)
      }).catch((err) => {
        reject(err)
      })
    })
  },
  loadTransactions () {
    return new Promise((resolve, reject) => {
      http.main.get('/transactions').then(async (res) => {
        resolve(res.data)
      }).catch((err) => {
        reject(err)
      })
    })
  },
  async waitUntilTransactionInLedger (txId) {
    while (true) {
      const txStatus = await getTransactionStatus(txId)
      if (txStatus == 'pending') {
        wait(1)
        continue
      }
      if (txStatus == 'expired') throw new Error('Transaction expired')
      break
    }
  },
  async submitTransaction (txId) {
    await executeWithSpinner(() => new Promise((resolve, reject) => {
      http.main.post('/transactions/submit', {id: txId}).then(async (res) => {
        await this.waitUntilTransactionInLedger(res.data.transactionId)
        resolve(res.data)
      }).catch((err) => {
        reject(err)
      })
    }), {loading: 'submitting', success: 'submitted', fail: 'txn_fail'})
  },
  async verifyTransaction (txId) {
    await executeWithSpinner(() => new Promise((resolve, reject) => {
      http.main.post('/transactions/verify', {id: txId}).then(async (res) => {
        resolve(res.data)
      }).catch((err) => {
        reject(err)
      })
    }))
  },
  async rejectTransaction (txId) {
    await executeWithSpinner(() => new Promise((resolve, reject) => {
      http.main.post('/transactions/reject', {id: txId}).then(async (res) => {
        resolve(res.data)
      }).catch((err) => {
        reject(err)
      })
    }), {
      loading: 'reject_loading',
      success: 'reject_success',
      fail: 'reject_fail'
    })
  }
}

function getTransactionStatus (txId) {
  return new Promise((resolve, reject) => {
    http.main.get(`/transactions/cardano/${txId}`).then(async (res) => {
      resolve(res.data)
    }).catch((err) => {
      reject(err)
    })
  })
}

function wait(seconds) {
  return new Promise(resolve => setTimeout(resolve, seconds * 1000))
};
